import { render } from "./PageFocused.vue?vue&type=template&id=4581d8ac"
import script from "./PageFocused.vue?vue&type=script&lang=js"
export * from "./PageFocused.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/containers/PageFocused.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4581d8ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4581d8ac', __exports__)) {
    api.reload('4581d8ac', __exports__)
  }
  
  module.hot.accept("./PageFocused.vue?vue&type=template&id=4581d8ac", () => {
    api.rerender('4581d8ac', render)
  })

}


export default __exports__